const sections = document.querySelectorAll<HTMLElement>('.js-archive-section');

const filters = document.querySelectorAll('.js-filter');

const postsPerPage = 6;
const states = {
  IDLE: 0,
  WORKING: 1,
  DONE: 2,
};

let state = states.IDLE;

function init() {
  sections.forEach((section) => {
    const moreBtn = section.querySelector('.js-view-more');
    const type = section.dataset.type;
    const container = section.querySelector('.js-posts-container');
    const filter = section.querySelector('.js-filter');

    moreBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const pageAttr = e.currentTarget
        ? (e.currentTarget as HTMLElement).dataset.page
        : null;
      let page = pageAttr ? parseInt(pageAttr) : 1;
      let category = filter?.querySelector<HTMLElement>('.js-blog-sortBy-toggle')?.dataset.value;

      getNextPage(page + 1, type, category, container);
    });

    filter?.addEventListener('change', (e: CustomEvent) => {
      const category = e.detail.value;

      getNextPage(1, type, category, container);
    });
  });

  filters.forEach((filter) => {
    const toggle = filter?.querySelector('.js-blog-sortBy-toggle');
    const list = filter?.querySelector('.js-blog-sortBy-list');

    const options = filter?.querySelectorAll<HTMLElement>('.js-sortBy-btn');

    toggle?.addEventListener('click', (event) => {
      event.preventDefault();
      if (toggle.classList.contains('sortBy__toggle--open')) {
        toggle.classList.remove('sortBy__toggle--open');
        list?.setAttribute('aria-hidden', 'true');
      } else {
        toggle.classList.add('sortBy__toggle--open');
        list?.removeAttribute('aria-hidden');
      }
    });

    options?.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        let oldBtn = filter.querySelector('[data-selected]');
        let value = option.dataset.value;

        oldBtn?.removeAttribute('data-selected');

        option.setAttribute('data-selected', '');

        if (toggle) {
          toggle.setAttribute('data-value', value as string);
          toggle.innerHTML = option.innerHTML;
        }

        // close dropdown
        toggle?.classList.remove('sortBy__toggle--open');
        list?.setAttribute('aria-hidden', 'true');

        // Emit filter change event
        filter.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { value: value } }));
      });
    });

    document.addEventListener('click', (e) => {
      const target = e.target as Element;
      if (!target.closest('.js-filter')) {
        toggle?.classList.remove('sortBy__toggle--open');
        list?.setAttribute('aria-hidden', 'true');
      }
    });
  });
}

async function getNextPage(page, type, category, container) {
  if (state === states.WORKING) {
    return;
  }

  const moreBtn = document.querySelector<HTMLElement>(`.js-view-more[data-type="${type}"]`);
  moreBtn?.classList.add('resource-archive__view-more--hidden');

  const emptyMsg = container.querySelector('.js-empty-msg');

  if (page === 1) {
    emptyMsg.classList.add('resource-archive__empty-msg--hidden');
    container.querySelectorAll('.resource-archive__grid-item').forEach((e) => e.remove());
  }

  const { html, items } = await fetch(
    `/blog/paginate?type=${type}&page=${page}&category=${category}`,
  ).then((r) => {
    if (moreBtn) {
      moreBtn.dataset.page = page;
    }

    return r.json();
  });

  const itemsToAppend = html.map((post) => {
    let div = document.createElement('div');
    div.classList.add(
      'resource-archive__grid-item',
      'resource-archive__grid-item--hidden',
    );

    div.innerHTML = post;

    return div;
  });

  if (page === 1 && !itemsToAppend.length) {
    moreBtn?.classList.add('resource-archive__view-more--hidden');
    emptyMsg?.classList.remove('resource-archive__empty-msg--hidden');
    return;
  }

  container.append(...itemsToAppend, emptyMsg);

  let newPosts = container.querySelectorAll(
    '.resource-archive__grid-item--hidden',
  );

  newPosts.forEach((post) => {
    post.classList.remove('resource-archive__grid-item--hidden');
  });

  if (items.skip + postsPerPage >= items.total) {
    moreBtn?.classList.add('resource-archive__view-more--hidden');

    state = states.DONE;
  } else {
    moreBtn?.classList.remove('resource-archive__view-more--hidden');
    state = states.IDLE;
  }
}

init();
